import { parsePhoneNumberCharacter } from "../../../libphonenumber-js/es6/parseIncompletePhoneNumber.js";
function parsePhoneNumberCharacter_(character, prevParsedCharacters, context) {
  if (!(context && context.ignoreRest)) {
    var emitEvent = function(eventName) {
      if (context)
        switch (eventName) {
          case "end":
            context.ignoreRest = !0;
            break;
        }
    };
    return parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent);
  }
}
export {
  parsePhoneNumberCharacter_ as default
};
//# sourceMappingURL=parsePhoneNumberCharacter.js.map
